module.exports = __webpack_public_path__ + "static/media/adminProfile-removebg-preview.9a36cc77.png";